import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable, tap} from "rxjs";
import {StateService} from "./state.service";
import {inject, Injectable, Injector} from "@angular/core";

export const stateInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const injector = inject(Injector);
  return next(request).pipe(tap((event) => {
    if (event instanceof HttpResponse
      && event.body !== undefined && event.body !== null
      && Object.prototype.hasOwnProperty.call(event.body, 'cnf')
      && Object.prototype.hasOwnProperty.call(event.body, 'dataType')) {
      // @ts-ignore
      injector.get(ClientNotificationsHandler).handle((event.body as WrapperDto<any>).cnf);
    }
  }));
};

@Injectable({providedIn: 'root'})
export class ClientNotificationsHandler {
  private readonly stateService = inject(StateService);

  public handle(cnf: string[]): void {
    this.stateService.setClientNotifications(cnf);
  }
}
